import { render, staticRenderFns } from "./Package.vue?vue&type=template&id=c12d1618&scoped=true&"
import script from "./Package.vue?vue&type=script&lang=js&"
export * from "./Package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12d1618",
  null
  
)

export default component.exports